<div class="invalid-feedback d-block">
  <rdr-svg-icon key="help-text" color="var(--red6)" size="sm" class="icon"></rdr-svg-icon>
  <formly-validation-message [field]="field"></formly-validation-message>
</div>
